import React from "react";
import "./TCLines.css";
import { useLocation } from "react-router-dom";

export default function TC3L({
  Head,
  Title,
  TitleWidth,
  TitleWidthMob,
  TitlePadding,
  Para,
  ParaS,
  ParaFSize,
  ParaWidth,
  ParaWidthMob,
  Color,
  TextAlign,
  alignItems,
  TextTransForm,
}) {
  const location = useLocation();
  const isArabic = location.pathname.endsWith("/ar");
  const isMobile = window.innerWidth <= 768;
  return (
    <div className="TC2LContainer" style={{ alignItems: alignItems }}>
      {Head && (
        <div
          className={`TCL1 ${isArabic ? "arabic" : "english"}`}
          style={{ color: Color, textAlign: TextAlign, textTransform: TextTransForm }}
          dir={isArabic ? "rtl" : "ltr"}
        >
          {Head}
        </div>
      )}
      {Title && (
        <div
          className={`TCL2 ${isArabic ? "arabic" : "english"}`}
          style={{ width: isMobile ? TitleWidthMob : TitleWidth, color: Color, textAlign: TextAlign, textTransform: TextTransForm, padding: TitlePadding }}
          dir={isArabic ? "rtl" : "ltr"}
        >
          {Title}
        </div>
      )}
      {Para && (
        <div
          className={`TCL3 ${isArabic ? "arabic" : "english"}`}
          style={{
            width: isMobile ? ParaWidthMob : ParaWidth,
            color: Color,
            textAlign: TextAlign,
            textTransform: TextTransForm,
            fontSize: isMobile ? ParaFSize : "",
          }}
          dir={isArabic ? "rtl" : "ltr"}
        >
          {Para}
        </div>
      )}
      {ParaS && (
        <div
          className={`TCL3 ${isArabic ? "arabic" : "english"}`}
          style={{
            width: isMobile ? ParaWidthMob : ParaWidth,
            color: Color,
            textAlign: TextAlign,
            textTransform: TextTransForm,
            fontSize: isMobile ? ParaFSize : "",
          }}
          dir={isArabic ? "rtl" : "ltr"}
        >
          {ParaS}
        </div>
      )}
    </div>
  );
}
